module.exports = __webpack_public_path__ + "img/only-private-internal-dark.9a145a17.svg";